<template>
  <div class="tpf-mf-layout--items">
    <div
      v-for="li in componentsList"
      :key="li.label"
      class="tpf-mf-layout--items--panel"
    >
      <p class="tpf-mf-layout--items--panel--label" v-text="li.label" />
      <draggable
        v-model="li.list"
        class="tpf-mf-layout--items--panel--list"
        :group="{ name: 'TpFormGroup', pull: 'clone', put: false }"
        :clone="clone"
        :sort="false"
        animation="300"
      >
        <div v-for="item in li.list" :key="item.name" class="tpf-mf-layout--items--panel--list--li" v-text="item.label" />
      </draggable>
    </div>
  </div>
</template>

<script>
import draggable from 'vuedraggable'
import _ from 'lodash'
export default {
  name: 'Items',
  components: { draggable },
  props: {
    componentsList: {
      type: Array,
      default: _ => []
    }
  },
  methods: {
    clone(obj) {
      const newObj = Object.assign(_.cloneDeep(obj), { fieldId: `${obj.name}_${new Date().getTime()}` })
      return newObj
    }
  }
}
</script>
